/**
 * enum for setting block alignment, used by setAlignment API
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleAlignment {

    /**
     * Align left
     */
    Left,

    /**
     * Align center
     */
    Center,

    /**
     * Align right
     */
    Right,
}
